import React, { useState } from 'react'
import addToMailchimp from 'gatsby-plugin-mailchimp'
import FormSuccess from './FormSuccess'
import FormSignup from './FormSignup'

const Form = props => {
  const { success, mailingListURL } = props
  const intialStatus = { result: 'initial', msg: '', field: null }

  const [email, setEmail] = useState('')
  const [terms, setTerms] = useState(false)
  const [status, setStatus] = useState(intialStatus)

  const { result, field } = status
  const error = result === 'error'

  const handleEmailChange = e => {
    setEmail(e.target.value)
    if (error && field === 'email') {
      setStatus(intialStatus)
    }
  }

  const handleTermsChange = e => {
    setTerms(e.target.checked)
    if (e.target.checked && error && field === 'terms') {
      setStatus(intialStatus)
    }
  }

  const handleReset = e => {
    setStatus(intialStatus)
    setEmail('')
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (terms) {
      const awaitResult = await addToMailchimp(email, null, mailingListURL)
      setStatus({
        ...awaitResult,
        field: 'email',
      })
    } else {
      setStatus({
        result: 'error',
        msg: 'Please agree to the privacy terms',
        field: 'terms',
      })
    }
  }

  switch (result) {
    case 'success':
      return <FormSuccess handleReset={handleReset} text={success} />

    default:
      return (
        <FormSignup
          handleSubmit={handleSubmit}
          handleEmailChange={handleEmailChange}
          handleTermsChange={handleTermsChange}
          email={email}
          terms={terms}
          status={status}
          {...props}
        />
      )
  }
}

export default Form
